import type { LocaleCode, LocalizedString } from "@repo/shared/types";

/**
 * How much of a `LocalizedString` is filled in. Both translation surfaces show
 * it the same way — as the colour of the globe that opens their dialog — so the
 * status and the colours that render it live together here rather than being
 * spelled out once per component.
 */
export type TranslationStatus = "complete" | "partial" | "empty";

export function getTranslationStatus(
  i18nValue: LocalizedString,
  translationLangs: string[],
): TranslationStatus {
  // Nothing to translate into is not a gap, so it counts as done.
  if (translationLangs.length === 0) return "complete";

  const filledCount = translationLangs.filter((lang) =>
    i18nValue[lang as LocaleCode]?.trim(),
  ).length;

  if (filledCount === translationLangs.length) return "complete";
  if (filledCount === 0) return "empty";
  return "partial";
}

export const TRANSLATION_STATUS_COLORS: Record<TranslationStatus, string> = {
  complete: "text-success hover:text-success/80",
  partial: "text-warning hover:text-warning/80",
  empty: "text-muted-foreground hover:text-foreground",
};
